import { mapGetters } from 'vuex';

const LEASE_INCLUSION_ICON_BY_TAG = {
  MaintenanceIcon: 'Maintainence',
  TyresIcon: 'Tyres',
  RegistrationIcon: 'Registration',
  BreakdownAssistIcon: 'BreakdownAssist',
  TollManagementIcon: 'TollManagement',
  AccidentIcon: 'Accident',
  FuelIcon: 'Fuel',
  ReliefVehicleIcon: 'ReliefVehicle'
};

export default {
  data() {
    return {
      leaseInclusionsDefault: [
        { tag: 'MaintenanceIcon', label: 'Scheduled servicing & maintenance', icon: 'Maintainence' },
        { tag: 'TyresIcon', label: 'Replacement tyres', icon: 'Tyres' },
        { tag: 'RegistrationIcon', label: 'Annual registration', icon: 'Registration' },
        { tag: 'BreakdownAssistIcon', label: '24/7 roadside & breakdown assistance', icon: 'BreakdownAssist' },
        { tag: 'TollManagementIcon', label: 'Infringement & toll management', icon: 'TollManagement' },
        { tag: 'AccidentIcon', label: 'Accident management & driver support', icon: 'Accident' },
        { tag: 'FuelIcon', label: 'Fuel Cards or EV Charging', icon: 'Fuel' },
        { tag: 'ReliefVehicleIcon', label: 'Relief vehicle service', icon: 'ReliefVehicle' }
        // { tag: 'ComprehensiveInsuranceIcon', label: 'Comprehensive insurance', icon: ComprehensiveInsuranceIcon },
        // { tag: 'PresaleRateIcon', label: 'Pre-sale rate for excess KM charges', icon: PresaleRateIcon }
      ],
      leaseInclusionAU: [
        'MaintenanceIcon',
        'TyresIcon',
        'RegistrationIcon',
        'BreakdownAssistIcon',
        'TollManagementIcon',
        'AccidentIcon',
        'FuelIcon',
        'ReliefVehicleIcon'
        // 'ComprehensiveInsuranceIcon',
        // 'PresaleRateIcon'
      ],
      leaseInclusionNZ: [
        'MaintenanceIcon',
        'TyresIcon',
        'RegistrationIcon',
        'BreakdownAssistIcon',
        // 'TollManagementIcon',
        'AccidentIcon',
        'FuelIcon',
        'ReliefVehicleIcon'
        // 'ComprehensiveInsuranceIcon',
        // 'PresaleRateIcon'
      ]
    };
  },
  computed: {
    configuredLeaseInclusions() {
      const leaseInclusions = this.calculator?.leaseInclusions;
      if (!Array.isArray(leaseInclusions) || leaseInclusions.length === 0) {
        return null;
      }

      const isValid = leaseInclusions.every(
        (inclusion) =>
          inclusion &&
          typeof inclusion === 'object' &&
          typeof inclusion.label === 'string' &&
          Boolean(inclusion.label.trim()) &&
          LEASE_INCLUSION_ICON_BY_TAG[inclusion.tag] === inclusion.icon
      );
      const tags = isValid ? leaseInclusions.map(({ tag }) => tag) : [];

      return isValid && new Set(tags).size === tags.length ? leaseInclusions.map((leaseInclusion) => ({ ...leaseInclusion })) : null;
    },
    leaseInclusions() {
      if (this.configuredLeaseInclusions) {
        return this.configuredLeaseInclusions;
      }

      const isNZ = this.countryCode === 'NZ';

      if (isNZ) {
        return this.leaseInclusionsDefault.map((leaseInclusion) => {
          if (leaseInclusion.tag === 'FuelIcon') {
            return {
              ...leaseInclusion,
              label: 'Discounted Fuel Cards or EV Charging'
            };
          }

          return leaseInclusion;
        });
      }

      return this.leaseInclusionsDefault;
    },
    ...mapGetters({
      calculator: 'theme/getCalculator',
      orgProfile: 'theme/getOrgProfile'
    }),
    countryCode() {
      return this.orgProfile?.whiteLabel?.region;
    },
    leaseInclusionIcons() {
      if (this.configuredLeaseInclusions) {
        return this.configuredLeaseInclusions;
      }

      const isNZ = this.countryCode === 'NZ';

      if (isNZ) {
        return this.leaseInclusions.filter((icon) => this.leaseInclusionNZ.includes(icon.tag));
      }

      return this.leaseInclusions.filter((icon) => this.leaseInclusionAU.includes(icon.tag));
    },
    leaseInclusionIconsModal() {
      if (this.configuredLeaseInclusions) {
        return this.configuredLeaseInclusions.map((icon) => ({ ...icon, isIncluded: true }));
      }

      const isNZ = this.countryCode === 'NZ';

      if (isNZ) {
        return this.leaseInclusions
          .filter((icon) => this.leaseInclusionNZ.includes(icon.tag))
          .map((icon) => ({ ...icon, isIncluded: this.leaseInclusionNZ.includes(icon.tag) }));
      }

      return this.leaseInclusions
        .filter((icon) => this.leaseInclusionAU.includes(icon.tag))
        .map((icon) => ({ ...icon, isIncluded: this.leaseInclusionAU.includes(icon.tag) }));
    }
  }
};
